import { Component, Input, OnInit } from '@angular/core';

import { AppConfigService } from '../../../app-config.service';
import { DonneReferenceService } from '../../../shared/services/donne-reference.service';
import { EditerFichePropriete } from '../../propriete.state';
import { MiseDeFondsHelper } from '../../../tool-preautorisation/experimente/helpers/misedefonds-helper/mise-de-fonds-helper';
import { Observable } from 'rxjs';
import { ProprieteHelper } from '../../modeles/ProprieteHelper';
import { ProprieteModele } from '../../modeles/proprieteModel';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { ToolCapaciteService } from '../../../tool-capacite/tool-capacite.service';

@Component({
  selector: 'app-property-details-payments',
  templateUrl: './property-details-payments.component.html',
  styleUrls: ['./property-details-payments.component.scss'],
  standalone: false
})
export class PropertyDetailsPaymentsComponent implements OnInit {
  @Input()
  currentProperty: ProprieteHelper;

  capaciteStatus$: Observable<any> = this._toolCapaciteService.donneesResultat$;
  capaciteStatus: any;

  constructor(
    private readonly _store: Store,
    private readonly _donneesReferencesService: DonneReferenceService,
    private readonly _router: Router,
    private readonly _appConfigService: AppConfigService,
    private readonly _toolCapaciteService: ToolCapaciteService
  ) {}

  ngOnInit() {
    this.getCapaciteStatus();
  }

  private getCapaciteStatus() {
    this.capaciteStatus$.subscribe(data => {
      this.capaciteStatus = {
        isTooLow: data.isTooLow,
        isTooHigh: data.isTooHigh,
        miseDeFondsCourante: data.miseDeFonds
      };
    });
  }

  editProperty(): void {
    const currentProperty: ProprieteModele = this.currentProperty.propriete;
    this._store.dispatch(new EditerFichePropriete(currentProperty.id, 'propriete/detail/' + currentProperty.id));
  }

  get isBudgetImportant() {
    return this.capaciteStatus && this.capaciteStatus.isTooHigh;
  }

  get isBudgetInsuffisant() {
    return this.capaciteStatus && this.capaciteStatus.isTooLow;
  }

  get isMiseDeFondsInsuffisante() {
    return !this.isBudgetImportant && !this.isBudgetInsuffisant && this.currentProperty.miseDeFondTropBasse;
  }

  get miseDeFondsRequise() {
    return MiseDeFondsHelper.getMiseDeFondMinimale(this.currentProperty.prixTotal);
  }

  get fondsManquants() {
    return this.miseDeFondsRequise - this.capaciteStatus.miseDeFondsCourante;
  }

  get indicateur() {
    return this.currentProperty.indicateur;
  }

  get couleurIndicateur() {
    if (this.isBudgetImportant) {
      return 'vert';
    }

    if (this.isBudgetInsuffisant || this.isMiseDeFondsInsuffisante) {
      return 'blanc';
    }

    const mapping = {
      haut: 'rouge',
      moyen: 'jaune',
      bas: 'vert'
    };

    return this.indicateur && mapping[this.indicateur] ? mapping[this.indicateur] : null;
  }

  get hasThermometre() {
    return !this.isMiseDeFondsInsuffisante && !this.isBudgetInsuffisant && !this.isBudgetImportant;
  }

  get texteIndicateur() {
    if (this.isBudgetImportant) {
      return 'propriete.detail.thermometre.titre-budget-important';
    }

    if (this.isBudgetInsuffisant) {
      return 'propriete.detail.thermometre.titre-budget-insuffisant';
    }

    if (this.isMiseDeFondsInsuffisante) {
      return 'propriete.detail.thermometre.titre-mise-fonds-basse';
    }

    const mapping = {
      haut: 'propriete.detail.thermometre.titre-non-recommande',
      moyen: 'propriete.detail.thermometre.titre-risque',
      bas: 'propriete.detail.thermometre.titre-realiste'
    };

    return this.indicateur && mapping[this.indicateur] ? mapping[this.indicateur] : null;
  }

  editCapaciteFinanciere() {
    this._router.navigateByUrl('/capacite');
  }

  editMiseFonds() {
    this._toolCapaciteService.modifierEtape('mise-fonds', 'propriete/detail/' + this.currentProperty.propriete.id);
  }

  private get interestRate() {
    const langue = this._appConfigService.langue;
    const tauxInteret = this._donneesReferencesService.tauxInteret.toString();
    return langue === 'fr' ? tauxInteret.replace(/\./g, ',') : tauxInteret.replace(/,/g, '.');
  }

  get paymentTerms() {
    return {
      produit: this._donneesReferencesService.getCurrentReferentialProduit().label.toLowerCase(),
      amortissement: this._donneesReferencesService.getCurrentReferentialTypeAmortissement().label.toLowerCase(),
      taux: this.interestRate
    };
  }
}
